const Helper = {
  deepClone: (obj) => {
    return JSON.parse(JSON.stringify(obj))
  },
  // Retorna alterações no novo obj
  changedData: (newObj, oldObj) => {
    const keys = Object.keys(newObj)
    const result = {}

    for (const key of keys) {
      if (newObj[key] !== oldObj[key]) {
        result[key] = newObj[key]
      }
    }

    return result
  },
  maskForm: (data, mask) => {
    const dataSplit = data.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '').split('')
    dataSplit.forEach((character) => {
      mask = mask.replace('#', character)
    })
    return mask
  },
  formatarCPF(cpf) {
    if (!cpf) return
    const cpfLimpo = cpf.replace(/\D/g, '')
    if (cpfLimpo.length === 11) {
      return (
        cpfLimpo.substring(0, 3) +
        '.' +
        cpfLimpo.substring(3, 6) +
        '.' +
        cpfLimpo.substring(6, 9) +
        '-' +
        cpfLimpo.substring(9)
      )
    }
  },

  /**
   * @param {Object} error
   * @param {number} error.status
   * @param {string} error.message
   * @returns {boolean}
   */
  isExpectedError(error) {
    const sentryIgnoringEvents = [
      'Load failed', //erro de compilação css no safari
      'Failed to fetch', //erro estourando devido à extensão do chrome
      'NetworkError when attempting to fetch resource.', //erro relacionado ao navegador do cliente
      'Retries exceeded', //erro relacionado ao navegador do cliente
      'undefined', //erro não retornado
      'No error message', //erro não identificado
      'The operation is insecure.', //erro causado no header-footer devido a bloqueios de segurança do navegador (bloqueio de terceiros a acessar o localStorage)
      'Error sending broker request: timeout', //erro comumente relacionado a fechar a aba/navegador em requisição
      'The operation was aborted.', //erro gerado ao fechar ou mudar de aba em meio a requisição
      "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.", //erro ao desabilitar js ou localStorage no navegador
    ]

    const status = error.status
    if (status) {
      return [401, 403, 404, 422].includes(status)
    }
    const message = error.message
    if (error.message) {
      return sentryIgnoringEvents.includes(message)
    }

    return false
  },
  validEmail(email) {
    const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return regexEmail.test(email)
  },
  validCpf(cpf) {
    cpf = cpf.replace(/[^\d]+/g, '')

    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
      return false
    }

    let sum = 0
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let remainder = 11 - (sum % 11)
    let firstDigit = remainder >= 10 ? 0 : remainder

    sum = 0
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i)
    }
    remainder = 11 - (sum % 11)
    let secondDigit = remainder >= 10 ? 0 : remainder

    return firstDigit === parseInt(cpf.charAt(9)) && secondDigit === parseInt(cpf.charAt(10))
  },
}

export default Helper
